import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthService} from "../components/pages/Account/Service/auth.service";
import {Observable} from "rxjs";
import {Project} from "../Models/project";
import {Setup} from "../Models/setup";

@Injectable({
  providedIn: 'root'
})
export class SetupService {
baseUrl = environment.apiUrl + '/Setup';
    httpHeaders: HttpHeaders;

    constructor(private http: HttpClient ,authService: AuthService) {
        this.httpHeaders = new HttpHeaders({
            Authorization: `Bearer ${authService.getTokenAuth()}`,
        });
    }

  getSetup(): Observable<Setup> {
    return this.http.get<Setup>(`${this.baseUrl}/GetAll`, {
        headers: this.httpHeaders,
    });
  }
}
